import React, { ReactElement, useState } from 'react';
import CheckoutContainer from '../../containers/CheckoutContainer';

const CheckoutHome = ({ children }: { children: React.ReactNode }): ReactElement => {

    return (
        <CheckoutContainer>
            {children}
        </CheckoutContainer>
    );
};

export default CheckoutHome;
